export default "__VITE_ASSET__BXsHWI3$__"